import styled from "@emotion/styled";
import { Card, Modal, Space, Typography } from "antd";
import { FC } from "react";
import type { ParcelPhoneSearchGroup } from "./parcelPhoneSearchUtils";

const { Text } = Typography;

type ParcelPhonePickerModalProps = {
  open: boolean;
  groups: ParcelPhoneSearchGroup[];
  onClose: () => void;
  onSelect: (group: ParcelPhoneSearchGroup) => void;
};

/** Modal เลือกเบอร์โทร — layout ใกล้เคียงผลค้นหาลูกค้าใน CreateOrders */
const ParcelPhonePickerModal: FC<ParcelPhonePickerModalProps> = ({
  open,
  groups,
  onClose,
  onSelect,
}) => (
  <Modal
    title={`ผลการค้นหามีทั้งหมด ${groups.length} รายการ`}
    open={open}
    maskClosable={false}
    onCancel={onClose}
    width={600}
    style={{ top: 80 }}
    bodyStyle={{ maxHeight: 400, overflowY: "auto" }}
    footer={null}
  >
    {groups.map((group) => (
      <StyledCard
        key={group.telephone1}
        style={{
          width: "100%",
          backgroundColor: "#efefef",
          margin: "10px 0",
          padding: "10px",
        }}
        onClick={() => onSelect(group)}
      >
        <Space direction="vertical" size={4} style={{ width: "100%" }}>
          <Space direction="horizontal" size={8} wrap>
            <Text strong>{group.displayName}</Text>
            <Text type="secondary">({group.addressCount} ที่อยู่)</Text>
          </Space>
          <Text>
            เบอร์โทรศัพท์: <Text strong>{group.telephone1}</Text>
          </Text>
          {group.previewAddress ? (
            <Text type="secondary">ที่อยู่ล่าสุด: {group.previewAddress}</Text>
          ) : null}
        </Space>
      </StyledCard>
    ))}
  </Modal>
);

export default ParcelPhonePickerModal;

const StyledCard = styled(Card)`
  cursor: pointer;

  &:hover {
    border-color: #40a9ff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;
